/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Benefits_Item4Inputs */

const ja_playdata_home_benefits_item4 = /** @type {(inputs: Playdata_Home_Benefits_Item4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント期間中の視聴推移を追跡したい`)
};

const en_playdata_home_benefits_item4 = /** @type {(inputs: Playdata_Home_Benefits_Item4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I want to track viewership during an event period`)
};

/**
* | output |
* | --- |
* | "I want to track viewership during an event period" |
*
* @param {Playdata_Home_Benefits_Item4Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_benefits_item4 = /** @type {((inputs?: Playdata_Home_Benefits_Item4Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Benefits_Item4Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_benefits_item4(inputs)
	return en_playdata_home_benefits_item4(inputs)
});